import { render, staticRenderFns } from "./EditableCircle.vue?vue&type=template&id=2ed24463"
import script from "./EditableCircle.vue?vue&type=script&lang=js"
export * from "./EditableCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports